import { TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useAuthContext } from "../Auth";
import Button from "../components/UI/Button";
import { ProgressContainer } from "../components/UI/ProgressContainer";
import { handleError } from "../utils/utils";

function PageLogin() {
  const auth = useAuthContext();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const emailInputRef = useRef<HTMLInputElement>(null);
  const passwordInputRef = useRef<HTMLInputElement>(null);

  async function onSubmitHandler(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    const enteredEmail = emailInputRef.current!.value;
    const enteredPassword = passwordInputRef.current!.value;
    try {
      setIsLoading(true);
      await auth.login(enteredEmail, enteredPassword); // this will trigger Auth.onAuthStateChanged()
      setIsLoading(false);
    } catch (error) {
      handleError("Fehler beim Login", error, enqueueSnackbar, setIsLoading);
    }
  }

  return (
    <ProgressContainer size="max-w-sm" isLoading={isLoading}>
      <form noValidate>
        <TextField className="w-full mb-3" inputRef={emailInputRef} id="inputEmail" label="E-Mailadresse" type="email" placeholder="E-Mail eingeben..."/>
        <TextField className="w-full mb-3" inputRef={passwordInputRef} id="inputPassword" label="Passwort" type="password" placeholder="Passwort..."/>
        <div className="flex justify-between items-center mb-6">
          <Link to="/benutzer/passwordreset" className="text-blue-600 hover:text-blue-700 focus:text-blue-700 transition duration-200 ease-in-out">Passwort vergessen?</Link>
        </div>
        <Button type="submit" className="w-full" onClick={onSubmitHandler} disabled={isLoading}>Einloggen</Button>
        <p className="text-gray-800 mt-6 text-center">
          Kein Mitglied?
          <Link to="/benutzer/registrieren" className="text-blue-600 ml-1 hover:text-blue-700 focus:text-blue-700 transition duration-200 ease-in-out">Registrieren</Link>
        </p>
      </form>
    </ProgressContainer>
  );
}

export default PageLogin;
